import { AmendmentEvent } from '@cibo/core'
import { Stack, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const AmendmentCell = ({ traitId, year, params }: TraitCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/AmendmentEditor')
  const detail = params.row.findDetail({ traitId, year })
  const events = detail?.input?.events

  if (!events?.length) {
    return <Typography>{t('none')}</Typography>
  }

  return (
    <Tooltip
      title={
        <Stack spacing={1} padding={1}>
          {events.map(
            ({ date, amendmentType, method, rate, units }: AmendmentEvent, index: number) => (
                <Stack key={index}>
                  <Typography variant="body1">
                    {t('eventDate', { date: new Date(date) })}
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'background.default' }}>
                    {t(`type_${amendmentType}`)} - {t(`method_${method}`)}{' '}
                    {t('eventRate', { rate })} {t(`units_${units}`)}
                  </Typography>
                </Stack>
              )
          )}
        </Stack>
      }
    >
      <Typography variant="body1">{t('events', { count: events.length })}</Typography>
    </Tooltip>
  )
}
